import { DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormControl, NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TextMaskConfig } from 'angular2-text-mask';

import { FormControlComponent } from '../../../abstracts/form-control.abstract';
import { BasicInputTypeEnum } from '../../../enums/basic-input-type.enum';
import { IBasicInputConfig } from '../../../interfaces/basic-input-config.interface';

@Component({
    selector: 'app-basic-input',
    templateUrl: './basic-input.component.html',
    styleUrls: ['./basic-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: BasicInputComponent,
            multi: true,
        },
    ],
})
export class BasicInputComponent extends FormControlComponent implements OnInit, AfterViewInit {
    @Input() public inputConfig: IBasicInputConfig;
    @Input() public isValid = true;
    @Input() public classes = '';
    @Input() public icons: string;
    @Input() public readOnly = false;
    @Input() public maxLength = 2500;
    @Input() public trailingSign: string;
    @Input() public pattern?: string;

    @Input() public maskConfig: TextMaskConfig = { mask: false };

    @Output()
    public blurControl = new EventEmitter<void>();

    public placeholder: string;
    public inputId: string;
    public type: BasicInputTypeEnum;
    public basicInputTypeEnum = BasicInputTypeEnum;

    public inputControl = new FormControl();

    private ngControl: NgControl;

    constructor(private inj: Injector, private decimalPipe: DecimalPipe) {
        super();
    }

    ngOnInit(): void {
        this.placeholder = this.inputConfig.placeholder;
        this.inputId = this.inputConfig.inputId;
        this.type = this.inputConfig.type;
        this.icons = this.icons && this.icons.length > 0 ? 'input-icon icon ' + this.icons : '';
    }

    ngAfterViewInit(): void {
        this.ngControl = this.inj.get(NgControl);
        this.ngControl.control.markAllAsTouched = () => {
            this.markAsTouched();
        };
    }

    public writeValue(obj: any): void {
        if (this.type === BasicInputTypeEnum.NUMBER) {
            this.value = this.decimalPipe.transform(obj, '1.2-2');
        } else {
            this.value = obj;
        }
        this.inputControl.patchValue(this.value);
    }

    public onInput(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.inputControl.value;

        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public onInputNumber(): void {
        const regex: RegExp = new RegExp(/^\d+([.,]\d{0,2})?$/);
        if (!this.inputControl.value || this.inputControl.value === '') {
            this.value = '';
        }
        if (!regex.test(this.inputControl.value)) {
            this.inputControl.patchValue(this.inputControl.value.slice(0, -1), { emitEvent: false });
        }

        this.value = this.inputControl.value.replace(',', '.');

        this.onChange(this.value);
        if (!this.touched && this.value) {
            this.onTouched();
        }
    }

    public onBlur(): void {
        if (this.type === BasicInputTypeEnum.NUMBER) {
            this.inputControl.patchValue(this.decimalPipe.transform(this.value.replace(',', '.'), '1.2-2'), { emitEvent: false });
        }
        this.blurControl.emit();
        this.markAsTouched();
    }

    // prevent field to clear itself (ex: search input)
    public onEnter($event: Event): void {
        $event.preventDefault();
    }
}
